export default __webpack_public_path__ + "static/media/dataIconLight.25d3d8fb.svg";